import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from "@/components/ui/table";
import { Pause, Play, ArrowUpRight, Search } from "lucide-react";
import { toast } from "sonner";

export default function AdminBusinesses() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const load = async () => {
    const { data } = await api.get("/admin/businesses");
    setRows(data);
  };
  useEffect(() => { load(); }, []);

  const doAction = async (id, action, plan_code) => {
    await api.post(`/admin/businesses/${id}/action`, { action, plan_code });
    toast.success("Updated");
    load();
  };

  const filtered = q
    ? rows.filter((r) => JSON.stringify(r).toLowerCase().includes(q.toLowerCase()))
    : rows;

  return (
    <div className="space-y-6" data-testid="admin-businesses">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Businesses</h1>
          <p className="text-sm text-muted-foreground mt-1">Every company signed up on TheBillPro</p>
        </div>
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 w-64" data-testid="admin-biz-search" />
        </div>
      </div>
      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Business</TableHead>
              <TableHead>Owner</TableHead>
              <TableHead>Plan</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Registered</TableHead>
              <TableHead>Renewal</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map((r) => {
              const s = r.subscription;
              const status = s?.status || "no_sub";
              const variant = { active: "default", trial: "secondary", cancelled: "outline", expired: "destructive", suspended: "destructive" }[status] || "outline";
              return (
                <TableRow key={r.id} data-testid={`admin-biz-row-${r.id}`}>
                  <TableCell>
                    <div className="font-medium">{r.name}</div>
                    <div className="text-xs text-muted-foreground">{r.business_type}</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm">{r.owner_name}</div>
                    <div className="text-xs text-muted-foreground">{r.owner_email}</div>
                  </TableCell>
                  <TableCell>{r.plan?.name || "—"}</TableCell>
                  <TableCell><Badge variant={variant}>{status}</Badge></TableCell>
                  <TableCell className="text-xs">{(r.created_at || "").slice(0, 10)}</TableCell>
                  <TableCell className="text-xs">{(s?.next_billing_date || "").slice(0, 10) || "—"}</TableCell>
                  <TableCell className="text-right">
                    {status === "suspended" ? (
                      <Button variant="ghost" size="sm" onClick={() => doAction(r.id, "activate")} data-testid={`activate-${r.id}`}>
                        <Play size={14} className="mr-1" /> Activate
                      </Button>
                    ) : (
                      <Button variant="ghost" size="sm" onClick={() => doAction(r.id, "suspend")} className="text-destructive" data-testid={`suspend-${r.id}`}>
                        <Pause size={14} className="mr-1" /> Suspend
                      </Button>
                    )}
                    <Button variant="ghost" size="sm" onClick={() => doAction(r.id, "change_plan", "pro")} data-testid={`upgrade-${r.id}`}>
                      <ArrowUpRight size={14} className="mr-1" /> Pro
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
